// Dashboard Users retention page translations (en-US), loaded into dashboard.users.retention by ../en-US.users.js
module.exports = {
  menu: "Retention",
  title: "Retention",
  description: "How many of the users who signed up in the period come back after signing up.",
  kpis: {
    day: "Day {n} retention",
  },
  info: {
    day: "Users who first used the app in the period and came back on day {n} or later.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
  },
  hints: {
    noOldAccounts: "no sign-ups {n} days old",
    signupDays: "sign-ups from {start} to {end}",
    signupDay: "sign-ups of {start}",
  },
  day: "Day {n}",
  panels: {
    cohorts: {
      weekly: "Weekly cohorts — sign-ups in the period",
      monthly: "Monthly cohorts — sign-ups in the period",
      note: "Greener = higher retention. Only cohorts that start in the period; “–” = not enough time yet.",
    },
    curve: "Average retention curve",
    byCohort: "{first} and {second} retention per cohort",
  },
  panelInfo: {
    cohorts: "Share of each cohort of new users that came back to the app in each week or day after the first one.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    curve: "Average retention of the cohorts of the period on each day after the first one.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    byCohort: "Retention of each cohort on the two reference days.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
  },
};
